import React, { useState } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import Button from '../Elements/Button/Button';
import Checkbox from '../Elements/Checkbox/Checkbox';
import Input from '../Elements/Input/Input';
import { subscribeToNewsletter } from '../../actions/checkout';
import { getYear } from '../../utils/date';
import { purifier, scrollTo } from '../../utils/dom';
import { translate } from '../../utils/locale';
import { fieldValidation } from '../../utils/string';
import s from './Newsletter.scss';

const Newsletter = ({ setup, footer, callback = () => {}, variant = '', expanded = false, ...props }) => {
	const requiredFields = ['email', 'firstName', 'lastName'];
	const initialState = {
		email: '',
		firstName: '',
		lastName: '',
		interest: ['female', 'male'],
	};
	const [errors, updateErrors] = useState({});
	const [showingAll, toggleShowAll] = useState(expanded);
	const [fields, updateFields] = useState(initialState);
	const [sentState, updateSentState] = useState(false);

	const newsletterInputFocusHandler = () => {
		toggleShowAll(true);
		const top = window.pageYOffset || document.documentElement.scrollTop;
		if (variant !== 'Popup') scrollTo(200, top + 400);
	};

	const newsletterInputChangeHandler = (id, value) => {
		if (id.indexOf('Newsletter') !== -1) id = id.slice(0, id.indexOf('Newsletter'));
		if (id === 'birthday') {
			// Constrain birthday to valid format.
			value = value.split('-').map((datePart, i) => {
				if (i === 0 && datePart.length >= 4) {
					datePart = datePart.slice(0, 4);
					if (parseInt(datePart, 10) <= 1900) return 1900;
					if (parseInt(datePart, 10) >= parseInt(getYear(), 10) - 16) return parseInt(getYear(), 10) - 16;
					return datePart;
				}
				return datePart;
			}).join('-');
		}

		updateFields((prevState) => ({
			...prevState,
			[id]: value,
		}));

		updateErrors((prevState) => {
			const { [id]: removed, ...nextState } = prevState;
			return nextState;
		});

		updateSentState(false);
	};

	const newsletterInputBlurHandler = (id, value) => {
		id = id.slice(0, id.indexOf('Newsletter'));
		newsletterInputChangeHandler(id, value);

		if (fieldValidation(value, id) && requiredFields.indexOf(id) !== -1) {
			updateErrors((prevState) => ({
				...prevState,
				[id]: translate(setup, `error${fieldValidation(value, id)}`),
			}));
			return true;
		}
		return false;
	};

	const newsletterInterestChangeHandler = (id) => {
		const selectedInterest = id.slice(0, id.indexOf('Newsletter'));
		updateFields((prevState) => {
			let interest = prevState.interest.slice(0);
			if (interest.indexOf(selectedInterest) === -1) interest = [...interest, selectedInterest];
			else if (interest.length > 1) {
				interest = [...interest.slice(0, interest.indexOf(selectedInterest)), ...interest.slice(interest.indexOf(selectedInterest) + 1)];
			} else {
				interest = [...initialState.interest.slice(0, initialState.interest.indexOf(selectedInterest)), ...initialState.interest.slice(initialState.interest.indexOf(selectedInterest) + 1)];
			}

			return {
				...prevState,
				interest,
			};
		});
		updateSentState(false);
	};


	const submitNewsletterHandler = (e) => {
		e.preventDefault();

		let hasErrors = false;
		const $inputs = e.currentTarget.querySelectorAll('input');
		$inputs.forEach(($input) => {
			const id = $input.getAttribute('id');
			const value = $input.value;
			const returnErrors = newsletterInputBlurHandler(id, value);
			if (returnErrors) hasErrors = true;
		});

		if (hasErrors || Object.keys(errors).length > 0) return;

		props.subscribeToNewsletter(fields)
			.then(() => {
				window.setTimeout(() => {
					updateSentState(false);
					updateFields(initialState);
					if (callback) callback();
				}, 3000);

				updateSentState('sent');
				toggleShowAll(false);

				return true;
			})
			.catch((err) => {
				console.log('DEBUG: err', err);
				updateSentState('error');
				return false;
			});
	};

	return (
		<div className={[s.newsletter, (sentState === 'sent' ? s.newsletter__sent : null), (variant === 'Popup' ? s.newsletter__popup : null)].join(' ')}>
			{ variant !== 'Popup' && <div className={s.newsletter_title}>{ translate(setup, footer.newsletterTitle) }</div> }
			<form className={[s.newsletter_form, (sentState === 'error' ? s.newsletter_form__error : null)].join(' ')} onSubmit={submitNewsletterHandler}>
				<Input variantClasses={['input__newsletter']} id={`emailNewsletter${variant}`} type="email" isError={errors.email || false} value={fields.email} placeholder={translate(setup, 'labelEmail')} inputBlur={newsletterInputBlurHandler} inputChange={newsletterInputChangeHandler} inputFocus={newsletterInputFocusHandler} />
				<div className={[s.newsletter_form_continue, (showingAll ? s.newsletter_form_continue__showing : null)].join(' ')}>
					{/*
					<Input variantClasses={['input__newsletter']} id={`firstNameNewsletter${variant}`} type="text" isError={errors.firstName || false} value={fields.firstName} placeholder={translate(setup, 'labelFirstName')} inputBlur={newsletterInputBlurHandler} inputChange={newsletterInputChangeHandler} />
					<Input variantClasses={['input__newsletter']} id={`lastNameNewsletter${variant}`} type="text" isError={errors.lastName || false} value={fields.lastName} placeholder={translate(setup, 'labelLastName')} inputBlur={newsletterInputBlurHandler} inputChange={newsletterInputChangeHandler} />
					<Input variantClasses={['input__newsletter', 'label__newsletter']} id={`birthdayNewsletter${variant}`} type="date" min="1900-01-01" label={translate(setup, 'labelBirthday')} max={`${parseInt(getYear(), 10) - 16}-12-31`} value={fields.birthday} inputBlur={newsletterInputBlurHandler} inputChange={newsletterInputChangeHandler} />
					*/}
					<div className={s.newsletter_form_continue_interest}>
						<Checkbox variantClasses={['checkbox__newsletter']} id={`femaleNewsletter${variant}`} label={translate(setup, 'newsletterWomen')} selected={fields.interest.indexOf('female') !== -1} inputChange={newsletterInterestChangeHandler} />
						<Checkbox variantClasses={['checkbox__newsletter']} id={`maleNewsletter${variant}`} label={translate(setup, 'newsletterMen')} selected={fields.interest.indexOf('male') !== -1} inputChange={newsletterInterestChangeHandler} />
					</div>
					<Button variantClasses={['button__newsletter']} type="submit" text={translate(setup, footer.newsletterButton)} />
					<span className={s.newsletter_terms} dangerouslySetInnerHTML={{ __html: purifier(translate(setup, 'newsletterTerms')) }} />
				</div>
			</form>
			<span className={s.newsletter_thanks}>{translate(setup, footer.newsletterThanks)}</span>
		</div>
	);
};

const mapState = ({ environment }, { callback }) => ({ setup: environment.setup, footer: environment.footer, callback });

export default hot(module)(connect(mapState, { subscribeToNewsletter })(Newsletter));
